module.exports = (questions, answers) => {
  const view = {}
  view['Question Sections'] = questions
    .filter(({ name }) => answers[name])
    .map(question => `# ${question.name}\n\n${answersList(question, answers[question.name])}`)
    .join('\n')
  return view
}

function answersList (question, chosen) {
  return question
    .answers
    .map(({ name }) => name === chosen ? `[X] ${name}` : `[ ] ${name}`)
    .join(' ')
}
